import $api from "../http";

export default class CosmicService {
  static async getTexts() {
    const response = await $api.get("/api/content/texts");
    return response.data;
  }

  static async getPosts() {
    const response = await $api.get("/api/content/posts");
    return response.data;
  }

  static async getPostBySlug(slug) {
    const response = await $api.get(`/api/content/posts/${slug}`);
    return response.data;
  }

  static async fetchAnnouncement() {
    const response = await $api.get("/api/content/announcement");
    return response.data;
  }
}
